import { eventAddedToCalendar, addEventToCalendar } from './GroupsEventActionButton.locstring.json';
import loc from 'owa-localize';
import MeetingActionButton from './MeetingActionButton';
import addGroupEventToCalendar from '../actions/addGroupEventToCalendar';
import { MeetingRequestViewState } from '../store/schema/MeetingRequestViewState';
import { default as logMeetingMessageAction } from '../utils/logMeetingMessageAction';
import MeetingMessageActionEntrySource from '../store/schema/MeetingMessageActionEntrySource';
import { observer } from 'mobx-react';
import { ControlIcons } from 'owa-control-icons';

import * as React from 'react';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';

export interface GroupsEventActionButtonProps {
    item: MeetingRequestMessageType;
    viewState: MeetingRequestViewState;
    groupId: string;
    entrySource: MeetingMessageActionEntrySource;
}

@observer
export default class GroupsEventActionButton extends React.Component<
    GroupsEventActionButtonProps,
    {}
> {
    render() {
        const groupEventAdded = this.props.viewState.groupEventAdded;
        const buttonText = groupEventAdded ? loc(eventAddedToCalendar) : loc(addEventToCalendar);
        return (
            <div
                tabIndex={groupEventAdded ? 0 : -1}
                aria-label={groupEventAdded ? loc(eventAddedToCalendar) : null}
                aria-live={groupEventAdded ? 'polite' : 'off'}
                aria-atomic={true}
                role="status">
                <MeetingActionButton
                    text={buttonText}
                    onClick={this.onClick}
                    iconProps={{
                        iconName: ControlIcons.Add,
                    }}
                    disabled={groupEventAdded}
                />
            </div>
        );
    }

    private onClick = () => {
        addGroupEventToCalendar(this.props.item, this.props.groupId, this.props.viewState);
        logMeetingMessageAction('AddToMyCalendar', this.props.item, this.props.entrySource);
    };
}
